import {
  FaUsers,
  FaCode,
  FaTrophy,
  FaAward,
  FaBullseye,
  FaBookOpen,
  FaBolt,
  FaArrowRight,
  FaCheckCircle,
  FaRegClock,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const statsData = [
  {
    id: 1,
    value: "50K+",
    label: "Active Learners",
    icon: <FaUsers size={32} className="text-primary mb-3" />,
  },
  {
    id: 2,
    value: "1000+",
    label: "Practice Problems",
    icon: <FaCode size={32} className="text-primary mb-3" />,
  },
  {
    id: 3,
    value: "100+",
    label: "Contests Held",
    icon: <FaTrophy size={32} className="text-primary mb-3" />,
  },
  {
    id: 4,
    value: "25K+",
    label: "Certificates Issued",
    icon: <FaAward size={32} className="text-primary mb-3" />,
  },
];

const featureData = [
  {
    id: 1,
    title: "Placement Preparation",
    description:
      "Comprehensive preparation materials for technical interviews at top companies.",
    icon: <FaBullseye size={28} className="text-light" />,
    points: [
      "Company-wise questions",
      "Interview patterns",
      "Mock interviews",
      "Success tips",
    ],
    link:"/placement"
  },
  {
    id: 2,
    title: "Exam Practice",
    description:
      "Extensive collection of coding problems and practice tests across all topics.",
    icon: <FaBookOpen size={28} className="text-light" />,
    points: [
      "1000+ problems",
      "Multiple difficulty levels",
      "Detailed solutions",
      "Progress tracking",
    ],
    link:"/exam"
  },
  {
    id: 3,
    title: "Skills Certification",
    description:
      "Earn verified certificates that showcase your programming expertise.",
    icon: <FaAward size={28} className="text-light" />,
    points: [
      "Industry recognized",
      "Skill verification",
      "Portfolio boost",
      "Career advancement",
    ],
    link:"/certificate"
  },
  {
    id: 4,
    title: "Coding Tournaments",
    description:
      "Compete with peers in exciting coding contests and win amazing prizes.",
    icon: <FaTrophy size={28} className="text-light" />,
    points: [
      "Weekly contests",
      "Cash prizes",
      "Leaderboards",
      "Recognition badges",
    ],
    link:"/tournaments"
  },
];

//reusable component for statsData
const StatCard = ({ value, label, icon, delay }) => (
  <div className="col-6 col-md-3">
    <div
      className="text-center animate-scale-in bg-card p-4 rounded  h-100 card-custom-better"
      style={{ animationDelay: delay }}
    >
      {icon}
      <div className="display-6 fw-bold text-light mb-1">{value}</div>
      <small className="text-muted-custom">{label}</small>
    </div>
  </div>
);

//reusable component from featureData
const FeatureCard = ({ title, description, icon, points, delay ,link}) => (
  <div className="col-md-6">
    <div
      className="card h-100 card-custom-better"
      style={{ animationDelay: delay }}
    >
      <div className="card-body p-4">
        <div className="d-flex align-items-center mb-4">
          <div className="bg-gradient-primary p-3 rounded shadow-primary me-3">
            {icon}
          </div>
          <div>
            <h5 className="card-title mb-0 text-light">{title}</h5>
          </div>
        </div>
        <h6 className="card-text text-muted-custom mb-4">{description}</h6>
        <ul className="list-unstyled mb-4">
          {points.map((point, idx) => (
            <li key={idx} className="d-flex align-items-center mb-2">
              <FaCheckCircle className="text-success me-2" size={16} />
              <span className="text-muted-custom">{point}</span>
            </li>
          ))}
        </ul>
        <Link to={link} className="text-decoration-none text-white">
          <button className="btn w-100 d-flex align-items-center  text-white justify-content-between custom-button">
            Explore Feature
            <FaArrowRight size={16} />
          </button>
        </Link>
      </div>
    </div>
  </div>
);

const QuizCodeBetterSecton = () => {
  return (
    <>
      <section id="features" className="py-5">
        <div className="container">
          <div className="text-center mb-5 animate-fade-in">
            <h2 className="display-4 fw-bold text-white mb-4">
              Everything You Need to
              <span className="text-primary"> Code</span> Better
            </h2>
            <div className="d-flex justify-content-center">
              <p
                className="text-muted-custom text-center"
                style={{ maxWidth: "600px", fontSize: "20px" }}
              >
                From placement preparation to skill certification, we provide
                comprehensive tools to accelerate your coding journey.
              </p>
            </div>
          </div>
          {/* First 4 cards */}
          <div className="row g-4 mb-5">
            {statsData.map((stat, index) => (
              <StatCard
                key={stat.id}
                value={stat.value}
                label={stat.label}
                icon={stat.icon}
                delay={`${index * 0.1}s`}
              />
            ))}
          </div>
          {/* detailcards */}
          <div class="row g-4 mb-5">
            {featureData.map((feature, index) => (
              <FeatureCard
                key={feature.id}
                {...feature}
                delay={`${index * 0.2}s`}
              />
            ))}
          </div>

          {/* CTA box */}
          <div className="card card-custom-better animate-scale-in">
            <div className="card-body text-center p-5">
              <div className="d-flex align-items-center justify-content-center mb-4">
                <div className="bg-gradient-primary p-3 rounded-circle shadow-glow me-3">
                  <FaBolt size={28} className="text-light" /> {/* ⚡ icon */}
                </div>
                <h3 className="display-6 fw-bold mb-0 text-light">
                  Ready to Level Up?
                </h3>
              </div>
              <div className="d-flex justify-content-center mb-3">
                <p
                  className="text-muted-custom text-center"
                  style={{ maxWidth: "600px", fontSize: "16px" }}
                >
                  Join thousands of successful developers who have accelerated
                  their careers with CodeChamp.
                </p>
              </div>
              <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
                <Link to="/quiz" className="text-decoration-none text-white">
                  <button className="btn btn-gradient-primary btn-lg d-flex align-items-center justify-content-between gap-2 text-white glow-effect">
                    Start Free Trial
                    <FaArrowRight size={16} />
                  </button>
                </Link>
                <Link to="/quiz" className="text-decoration-none text-white">
                  <button className="btn btn-lg text-white d-flex align-items-center justify-content-between gap-2 custom-button">
                    <FaRegClock size={16} />
                    Schedule Demo
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default QuizCodeBetterSecton;
